module.exports = __webpack_public_path__ + "static/img/bryce.e587ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/bryce.jpg
// module id = PU9P
// module chunks = 1